import React from 'react';
import { seasonNames } from 'resources/common-values';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import CreateReactClass from 'create-react-class';
import RainbowChart from './rainbow-chart';
import NumberOrdinal from 'components/generic/number-ordinal';
import ComparisonUtils from './utils';
import NoPeriodDescription from './no-comparisons-period-message';

export default CreateReactClass({
    displayName: 'ComparisonsNormalGrowth',

    propTypes: {
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        comparisonDropdownPeriods: PropTypes.instanceOf(Immutable.Map),
        defaultComparisonPeriodFunction: PropTypes.func,
        selectedComparisonPeriod: PropTypes.instanceOf(Immutable.Map),
        isUserNormData: PropTypes.bool,
    },

    getSelectedPeriod() {
        return this.props.selectedComparisonPeriod
            ? this.props.selectedComparisonPeriod
            : this.props.defaultComparisonPeriodFunction(this.props.comparisonDropdownPeriods);
    },

    renderNormsPercentileNormal(subjectName, selectedComparisonPeriod) {
        const growthDescription =
            selectedComparisonPeriod && selectedComparisonPeriod.get('growthPercentile') !== null
                ? ComparisonUtils.getMeanDescription(selectedComparisonPeriod.get('growthPercentile'), false)
                : CommonStrings.comparisonsGrowthNoResult;
        const growthDescriptionClassName =
            growthDescription === CommonStrings.comparisonsGrowthNoResult
                ? 'no-score'
                : 'norms-percentile-normal-description';

        const achievementDescription =
            this.props.comparisonDropdownPeriods &&
            this.props.comparisonDropdownPeriods.get('achievementPercentile') !== null
                ? ComparisonUtils.getMeanDescription(
                      this.props.comparisonDropdownPeriods.get('achievementPercentile'),
                      false
                  )
                : CommonStrings.comparisonsGrowthNoResult;

        const achievementDescriptionClassName =
            achievementDescription === CommonStrings.comparisonsGrowthNoResult
                ? 'no-score'
                : 'norms-percentile-normal-description';

        let growthPercentile = selectedComparisonPeriod ? selectedComparisonPeriod.get('growthPercentile') : null;
        let achievementPercentile = this.props.comparisonDropdownPeriods
            ? this.props.comparisonDropdownPeriods.get('achievementPercentile')
            : null;

        return (
            <div
                className="norms-percentile-container-normal"
                id={`comparisons-norms-percentiles-container-normal-${subjectName}-${this.props.studentBid}`}
            >
                <div className="growth" style={{ width: '50%' }}>
                    <div
                        className="norms-percentile-normal-heading"
                        id={`comparisons-norms-percentiles-growth-heading-normal-${subjectName}-${this.props.studentBid}`}
                    >
                        GROWTH
                    </div>
                    <div
                        className={growthDescriptionClassName}
                        id={`comparisons-${growthDescriptionClassName}-growth-${subjectName}-${this.props.studentBid}`}
                    >
                        {growthDescription}
                    </div>
                    {growthPercentile ? (
                        <div
                            className="norms-percentile-value"
                            id={`comparisons-growth-percentile-value-normal-${subjectName}-${this.props.studentBid}`}
                        >
                            <NumberOrdinal value={growthPercentile} upperCase={true} />
                        </div>
                    ) : (
                        <NoPeriodDescription
                            id={`comparisons-growth-no-periods-description-normal-${subjectName}-${this.props.studentBid}`}
                            key="no-growth-periods"
                            className="no-periods-description"
                        />
                    )}
                    {growthPercentile ? (
                        <RainbowChart
                            key="comparisons-normal-growth-rainbow"
                            subjectBid={this.props.subjectBid}
                            studentBid={this.props.studentBid}
                            type="growth"
                            percentile={growthPercentile}
                            isExpanded={false}
                        />
                    ) : null}
                </div>
                <div className="achievement" style={{ width: '50%' }}>
                    <div
                        className="norms-percentile-normal-heading"
                        id={`comparisons-norms-percentiles-achievement-heading-normal-${subjectName}-${this.props.studentBid}`}
                    >
                        ACHIEVEMENT
                    </div>
                    <div
                        className={achievementDescriptionClassName}
                        id={`comparisons-${achievementDescriptionClassName}-achievement-${subjectName}-${this.props.studentBid}`}
                    >
                        {achievementDescription}
                    </div>
                    {achievementPercentile ? (
                        <div
                            className="norms-percentile-value"
                            id={`comparisons-achievement-percentile-value-normal-${subjectName}-${this.props.studentBid}`}
                        >
                            <NumberOrdinal value={achievementPercentile} upperCase={true} />
                        </div>
                    ) : (
                        <NoPeriodDescription
                            id={`comparisons-achievement-no-percentile-description-normal-${subjectName}-${this.props.studentBid}`}
                            key="no-achievement-percentile-message"
                            className="no-achievement-description"
                            altMessageText={CommonStrings.noComparisonPeriodsMessage.altMessage}
                        />
                    )}
                    {achievementPercentile ? (
                        <RainbowChart
                            key="comparisons-normal-achievement-rainbow"
                            subjectBid={this.props.subjectBid}
                            studentBid={this.props.studentBid}
                            type="achievement"
                            percentile={achievementPercentile}
                            isExpanded={false}
                        />
                    ) : null}
                </div>
            </div>
        );
    },

    getQuadrantChartDescription(subjectName, selectedComparisonPeriod) {
        let description = [];
        const achievement = 'Achievement';
        const growth = 'Growth';

        const getDescription = (percentage, type) => {
            const high = 'High ';
            const average = 'Average ';
            const low = 'Low ';

            return percentage === 50 ? average + type : percentage < 50 ? low + type : high + type;
        };

        if (selectedComparisonPeriod) {
            description.push(
                <div
                    className="quadrant-description screen-only"
                    key="growth"
                    id={`comparisons-quadrant-chart-growth-description-normal-${subjectName}-${this.props.studentBid}`}
                >
                    {getDescription(selectedComparisonPeriod.get('growthPercentile'), growth)}
                </div>
            );

            description.push(
                <div
                    className="quadrant-description screen-only"
                    key="achievement"
                    id={`comparisons-quadrant-chart-achievement-description-normal-${subjectName}-${this.props.studentBid}`}
                >
                    {getDescription(this.props.comparisonDropdownPeriods.get('achievementPercentile'), achievement)}
                </div>
            );
            description.push(
                <div
                    className="quadrant-description print-only"
                    key="growthAndAchievementPrintOnly"
                    id={`comparisons-quadrant-chart-growth-and-achievement-description-normal-${subjectName}-${this.props.studentBid}`}
                >
                    {getDescription(selectedComparisonPeriod.get('growthPercentile'), growth)} /{' '}
                    {getDescription(this.props.comparisonDropdownPeriods.get('achievementPercentile'), achievement)}
                </div>
            );
        } else {
            description.push(
                <div
                    className="no-score"
                    key="no-score"
                    id={`comparisons-quadrant-chart-no-score-description-normal-${subjectName}-${this.props.studentBid}`}
                >
                    {CommonStrings.comparisonsGrowthNoResult}
                </div>
            );
            description.push(
                <NoPeriodDescription
                    id={`comparisons-quadrant-chart-no-growth-periods-description-normal-${subjectName}-${this.props.studentBid}`}
                    key="no-growth-periods"
                    className="no-periods-description"
                    adjustOverflow={true}
                />
            );
        }
        return description;
    },

    renderQuadrantChartNormal(subjectName, selectedComparisonPeriod) {
        return (
            <div
                className="quadrant-chart-description-normal"
                id={`comparisons-quadrant-chart-description-normal-${subjectName}-${this.props.studentBid}`}
            >
                {this.getQuadrantChartDescription(subjectName, selectedComparisonPeriod)}
            </div>
        );
    },

    renderGrowthAndAchievementContent(subjectName, selectedComparisonPeriod) {
        const normPercentileDisplay = this.props.isUserNormData
            ? CommonStrings.comparisonsGrowthAndAchievement.userNormPercentileHeader
            : CommonStrings.comparisonsGrowthAndAchievement.normPercentileHeader;
        return (
            <div
                className="growth-and-achievement-normal"
                id={`comparisons-growth-and-achievement-normal-${subjectName}-${this.props.studentBid}`}
            >
                <div
                    className="norms-percentile-normal"
                    id={`comparisons-norms-percentile-normal-${subjectName}-${this.props.studentBid}`}
                    style={{ width: '60%' }}
                >
                    <header className="module-header">
                        <h3>{normPercentileDisplay}</h3>
                    </header>
                    {this.renderNormsPercentileNormal(subjectName, selectedComparisonPeriod)}
                </div>
                <div
                    className="quadrant-chart-normal"
                    id={`comparisons-quadrant-chart-normal-${subjectName}-${this.props.studentBid}`}
                >
                    <header className="module-header">
                        <h3>Quadrant Chart</h3>
                    </header>
                    {this.renderQuadrantChartNormal(subjectName, selectedComparisonPeriod)}
                </div>
            </div>
        );
    },

    render() {
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        const selectedComparisonPeriod = this.getSelectedPeriod();
        return (
            <div
                className="data-row"
                id={`comparisons-growth-and-achievement-normal-${subjectName}-${this.props.studentBid}`}
            >
                <h3 className="comparisons-heading">GROWTH & ACHIEVEMENT MEASURES</h3>
                {this.renderGrowthAndAchievementContent(subjectName, selectedComparisonPeriod)}
            </div>
        );
    },
});
